import { render } from "./MTooltip.vue?vue&type=template&id=ac738e52"
import script from "./MTooltip.vue?vue&type=script&lang=js"
export * from "./MTooltip.vue?vue&type=script&lang=js"

import "./MTooltip.vue?vue&type=style&index=0&id=ac738e52&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__